<xemex-card [title]="'companies.detailTabs.general.defaultMeterRole.label' | translate">
  <form [formGroup]="form" class="flex flex-col gap-4">
    <p class="text-sm text-text-secondary">
      {{ 'companies.detailTabs.general.defaultMeterRole.description' | translate }}
    </p>

    <xemex-select-field [label]="'companies.detailTabs.general.defaultMeterRole.label' | translate">
      <mat-select
        formControlName="defaultMeterRole"
        [disabled]="!canEdit() || isLoading()"
        [hideSingleSelectionIndicator]="true"
      >
        <mat-select-trigger>
          {{ 'meterRoles.' + form.controls.defaultMeterRole.value | translate }}
        </mat-select-trigger>
        @for (role of meterRoleOptions; track role) {
          <mat-option [value]="role">
            <div class="flex items-center gap-2 py-1">
              <mat-icon class="text-text-muted">{{ meterRoleIcons[role] }}</mat-icon>
              <div>
                <div class="text-sm font-medium">{{ 'meterRoles.' + role | translate }}</div>
                <div class="text-xs text-muted">
                  {{ 'meterRoles.descriptions.' + role | translate }}
                </div>
              </div>
            </div>
          </mat-option>
        }
      </mat-select>
    </xemex-select-field>

    @if (canEdit()) {
      <div class="flex justify-end">
        <xemex-filled-button [disabled]="!isDirty() || isSaving()" (click)="onSave()">
          {{ 'companies.detailTabs.general.defaultMeterRole.saveButton' | translate }}
        </xemex-filled-button>
      </div>
    }
  </form>
</xemex-card>
